import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Image, Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import './AdminBusinessTools.css'; // Custom CSS for unique styling

const AdminBusinessTools = () => {
  const [businessCards, setBusinessCards] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const imagePath = "https://drdprints.com/uploads/businesscards/";

  useEffect(() => {
    fetchBusinessCards();
  }, []);

  // Fetch business cards from the API
  const fetchBusinessCards = async () => {
    try {
      const response = await axios.get('https://drdprints.com/api/get-productbusinesscards');
      setBusinessCards(response.data.product_business_cards);
    } catch (error) {
      console.error('Error fetching business cards:', error);
    }
  };

  // Handle opening the modal for adding a new card
  const handleAdd = () => {
    setEditData(null);
    setTitle('');
    setDescription('');
    setImage(null);
    setShowModal(true);
  };

  // Handle opening the modal for editing an existing card
  const handleEdit = (data) => {
    setEditData(data);
    setTitle(data.b_card_title);
    setDescription(data.b_card_desc);
    setImage(data.b_card_image);
    setShowModal(true);
  };

  // Handle deleting a card
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://drdprints.com/api/deleteproductbusinesscard/${id}`);
      fetchBusinessCards();
    } catch (error) {
      console.error('Error deleting business card:', error);
    }
  };

  // Handle saving (adding or updating) a card
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('b_card_title', title);
    formData.append('b_card_desc', description);
    if (image) formData.append('b_card_image', image); // Append the image file

    try {
      if (editData) {
        // Update existing card
        await axios.put(`https://drdprints.com/api/update-productbusinesscard/${editData.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        // Add new card
        await axios.post('https://drdprints.com/api/store-productbusinesscard', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      setShowModal(false);
      fetchBusinessCards();
    } catch (error) {
      console.error('Error saving business card:', error);
    }
  };

  return (
    <Container className="admin-business-tools mt-4">
      <h2 className="admin-business-tools__header mb-4 text-center">Admin - Business Tools</h2>
      <Row className="admin-business-tools__controls justify-content-end mb-3">
        <Col xs="auto">
          <Button variant="primary" onClick={handleAdd} className="admin-business-tools__add-button">
            Add Business Card
          </Button>
        </Col>
      </Row>
      <Table responsive striped bordered hover className="admin-business-tools__table mb-3">
        <thead className="admin-business-tools__table-head">
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Images</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className="admin-business-tools__table-body">
          {businessCards.map((card) => (
            <tr key={card.id} className="admin-business-tools__table-row">
              <td>{card.id}</td>
              <td>{card.b_card_title}</td>
              <td className="admin-business-tools__description">{card.b_card_desc}</td>
              <td className="text-center">
                {card.b_card_image ? (
                  <Image
                    src={`${imagePath}${card.b_card_image}`}
                    alt={card.b_card_title}
                    thumbnail
                    className="admin-business-tools__image"
                  />
                ) : (
                  <span className="admin-business-tools__no-image">No Image</span>
                )}
              </td>
              <td className="text-center">
                <Button
                  variant="warning"
                  onClick={() => handleEdit(card)}
                  className="admin-business-tools__edit-button me-2 mb-1"
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  onClick={() => handleDelete(card.id)}
                  className="admin-business-tools__delete-button mb-1"
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for adding/editing business cards */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered className="admin-business-tools__modal">
        <Modal.Header closeButton className="admin-business-tools__modal-header">
          <Modal.Title>{editData ? 'Edit Business Card' : 'Add Business Card'}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} encType="multipart/form-data">
          <Modal.Body className="admin-business-tools__modal-body">
            <Form.Group controlId="formTitle" className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formDescription" className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formImage" className="mb-3">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setImage(e.target.files[0])}
                required={editData === null} // Make it required only for adding a new card
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="admin-business-tools__modal-footer">
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button type="submit" variant="primary">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
};

export default AdminBusinessTools;
